// Fuentes TTF que se pasan al Viewer (Three.js) para renderizar TEXT/MTEXT del DXF.
// El TextRenderer las invoca de forma lazy — solo descarga las que necesita por glyph.
//
// Cobertura combinada de las 4:
//   - Roboto:          latín básico/extendido + número/símbolos comunes
//   - NotoSansDisplay: latín extendido + caracteres acentuados
//   - HanaMinA:        CJK (chino/japonés básico)
//   - NanumGothic:     coreano y respaldo CJK
//
// IMPORTANTE: NO usamos `import "...ttf"` aquí. Webpack/Mix procesa esos imports
// con asset modules generando URLs con hash que no quedan en mix-manifest.json y
// no resuelven en producción (Vapor sirve assets desde CloudFront vía ASSET_URL).
// El síntoma era opentype.js parseando `<!DOCTYPE...>` porque CloudFront caía al
// fallback HTML del SPA.
//
// Solución: referenciamos las URLs estáticas en /public/fonts/ (los archivos ya
// están commiteados allí) y prefijamos con process.env.ASSET_PATH (definido por
// DefinePlugin en webpack.mix.js — '/' en local, URL CloudFront en producción).
const BASE = (typeof process !== 'undefined' && process.env && process.env.ASSET_PATH
  ? process.env.ASSET_PATH
  : '/').replace(/\/$/, '')

export const FONTS = [
  `${BASE}/fonts/Roboto-LightItalic.ttf`,
  `${BASE}/fonts/NotoSansDisplay-SemiCondensedLightItalic.ttf`,
  `${BASE}/fonts/HanaMinA.ttf`,
  `${BASE}/fonts/NanumGothic-Regular.ttf`,
]
